import {useEffect,useState} from 'react';
import {useLocation} from 'react-router-dom';
import './MobileChances.css';

export function useMobileDesign() {
 const {search}=useLocation();
 const [narrow,setNarrow]=useState(()=>window.matchMedia('(max-width: 1100px)').matches);
 useEffect(()=>{const m=window.matchMedia('(max-width: 1100px)');const update=()=>setNarrow(m.matches);m.addEventListener('change',update);return()=>m.removeEventListener('change',update);},[]);
 return narrow && new URLSearchParams(search).get('redesign_v2')!=='0';
}

export default function MobileDesign() {
 const mobile=useMobileDesign();
 const active=mobile;
 useEffect(()=>{document.body.dataset.mobileDesign=active?'true':'false';return()=>{delete document.body.dataset.mobileDesign;};},[active]);
 return null;
}
